module.exports = __webpack_public_path__ + "static/media/aws.e4397127.png";